import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { VendorPersonType } from '@econtractor/types';
import { ClientContacts } from 'modules/client';
import { createVendorPersonContactsAdapter } from './model/vendorPersonContactsAdapter';

interface OffVendorPersonContactsProps {
    vendorId: number;
    person: VendorPersonType | null;
    onHide: () => void;
}

const OffVendorPersonContacts = ({ vendorId, person, onHide }: OffVendorPersonContactsProps) => {
    const { t } = useTranslation(['Vendors']);
    const show = person !== null;
    const adapter = createVendorPersonContactsAdapter(vendorId);

    return (
        <Offcanvas show={show} onHide={onHide} placement="end" className="off-vendor-person-contacts">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title className="me-auto">
                    {t('persons.contactsTitle')}
                    {person?.fullName ? (
                        <span className="text-muted fs-6 d-block fw-normal">{person.fullName}</span>
                    ) : null}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                {person ? (
                    <div className="px-3 pb-4">
                        <ClientContacts mode="edit" ownerId={person.ID} adapter={adapter} />
                    </div>
                ) : null}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffVendorPersonContacts;
